// extracted by mini-css-extract-plugin
export default {"root":"PlainMenuItem_root__AN6Tz","disabled":"PlainMenuItem_disabled__FecAp","placeHolderShimmer":"PlainMenuItem_placeHolderShimmer__oM3nV"};